<template>
  <div>
    <div class="flex flex-col items-center my-5">
      <div>
        <empty-state-2 />
      </div>
      <h3 class="font-semibold text-center text-xl text-root-2">
        No
        {{ isWithdrawalMethodUse ? 'Withdrawal Method' : 'Beneficiary ' }} Saved
        Yet
      </h3>
      <p
        class="font-light text-root-4 text-xs flex items-center justify-center mt-2"
      >
        <span class="text-center">
          Your
          {{ isWithdrawalMethodUse ? 'Withdrawal Methods' : 'Beneficiaries ' }}
          will show up here once you add them.
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    use: {
      type: String,
      default: ''
    }
  },
  computed: {
    isWithdrawalMethodUse () {
      return this.use === 'withdrawal-method'
    }
  },
  components: {
    EmptyState2: () => import('@/assets/v2/icons/EmptyState2.vue')
  }
}
</script>

<style></style>
